import React from 'react';

const LargeCancelIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M30 10L10 30M10 10L30 30'
        stroke='#5B91F5'
        strokeWidth='7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LargeCancelIcon;
